/*
 * @Author: Risker-C
 * @Date: 2021-09-13 20:41:54
 * @LastEditTime: 2021-09-13 21:35:04
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\components\YhFormBox\item\FormTextArea.tsx
 */
import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Form } from "antd";
import TextArea from "antd/lib/input/TextArea";

export const __FormTextArea: FC<IFormItem> = ({ placeholder, fieldLabel, fieldName, ...props }) => {
    return (
        <Form.Item
            label={fieldLabel}
            name={fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol}
        >
            <TextArea
                disabled={props.disable}
                allowClear={props.allowClear}
                placeholder={placeholder ? placeholder : typeof fieldLabel === "string" ? fieldLabel : ""}
            />
        </Form.Item>
    )
}